import React from 'react';

import Tridi from 'react-tridi';
import 'react-tridi/dist/index.css';

const Car360View = ({car}) => {
    var currentCar = car.Nombre.split(" ")
    var carSelected = ''
    var i
    for(i = 0; i < currentCar.length; i++){
        carSelected = carSelected + currentCar[i]
    }
    
    return(
            <Tridi location={'./images/'+carSelected+"/"} format="jpg" count="4" dragInterval={15} touchDragInterval={15}/>
    )
}

export default Car360View;